<template>
  <v-dialog
    v-model="isDialogOpen"
    max-width="600"
    @click:outside="onClose"
    @keydown.esc="onClose"
  >
    <v-card>
      <v-card-title>Импорт геометрии</v-card-title>

      <v-card-text>
        <v-container>
          <h4>Выберите файл для импорта</h4>
          <v-file-input
            label="Выберите файл"
            accept="text/plain"
            @change="onImportFile($event)"
          />
        </v-container>
      </v-card-text>

      <v-card-actions>
        <div class="flex-grow-1" />
        <v-btn
          color="blue darken-1"
          text
          @click="onClose"
        >
          Отмена
        </v-btn>

        <v-btn
          color="success darken-1"
          text
          :disabled="!isValidData"
          @click="addImportFile"
        >
          Выполнить импорт данных
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions } from 'vuex';
import { feature } from '@turf/turf';
import parseJson from '@/utils/parseJson';
import parseWkt from '@/utils/parseWkt';

export default {
  name: 'import-file-dialog',

  props: {
    isDialogOpen: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    isValidData: false,
    importFile: null,
  }),
  computed: {},

  beforeDestroy() {
    this.isValidData = false;
    this.importFile = null;
  },

  methods: {
    ...mapActions(['showNotify']),

    showError() {
      const errorMessage = 'Неверный формат данных. Проверьте файл.';
      this.showNotify({ type: 'error', message: errorMessage });
      this.isValidData = false;
    },

    async onImportFile(file) {
      try {
        if (!file) {
          this.isValidData = false;
          return;
        }

        const jsonFile = parseJson(await file.text());
        if (jsonFile) {
          this.importFile = jsonFile;
        } else {
          const wktFile = parseWkt(await file.text());
          this.importFile = wktFile && feature(wktFile);
        }

        if (!this.importFile) {
          throw new Error('Неверный формат данных. Проверьте файл.');
        }
        this.isValidData = true;
      } catch (error) {
        this.showError();
        console.error(error);
        this.isValidData = false;
      }
    },

    addImportFile() {
      this.$emit('add-import-file', this.importFile);
    },

    onClose() {
      this.$emit('closed');
    },
  },
};
</script>
